import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, closingNeeds, heroImage, product } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-63" data-mp="15d41wd2fx2qi">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-64" data-mp="15fq92blf5g87">
        <h2 className="mx-auto max-w-2xl font-display text-[2.1rem] font-extrabold leading-tight tracking-tight text-plum-700 md:text-[2.9rem]" data-id="element-65" data-mp="1jbaga9rsc9zs">
          No necesitás <span className="italic text-gold-700" data-id="element-66" data-mp="1t37t1kyfza0m">otro PDF suelto</span>
        </h2>

        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted" data-id="element-67" data-mp="1o43m70yzpodg">
          Necesitás poder abrir una carpeta y encontrar:
        </p>

        <ul className="mx-auto mt-8 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-68" data-mp="2245wo24yxfio">
          {closingNeeds.map(need => <li key={need} className="rounded-lg bg-white px-5 py-4 text-left font-medium text-ink shadow-card ring-1 ring-plum-100" data-id="element-69" data-mp="1x2gnyt57xdxr">
              {need}
            </li>)}
        </ul>

        <p className="mt-12 font-display text-xl font-extrabold italic text-gold-700" data-id="element-70" data-mp="x38yfqdjfs3s">Eso es:</p>

        <img src={heroImage} alt="El Puente del Adiós completo: 4 tomos, 30 tarjetas y 3 bonos" className="mx-auto mt-8 w-full max-w-xl" width={1256} height={1256} loading="lazy" data-id="element-71" data-mp="123ek8px4mkdy" />

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border-2 border-gold-500 bg-white p-8 shadow-lift md:p-10" data-id="element-72" data-mp="1b1qkzkrpiyk4">
          <h3 className="font-display text-2xl font-extrabold leading-tight tracking-tight text-plum-700 md:text-[2rem]" data-id="element-73" data-mp="1fwmd0kwy1lx8">
            {product.name}
          </h3>
          <p className="mt-3 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-teal-600" data-id="element-74" data-mp="1pu0sah74s4ny">
            4 tomos + 30 tarjetas + 3 bonos
          </p>

          <p className="mt-7 text-muted line-through" data-id="element-75" data-mp="3qufels0efot7">Valor regular: {product.listPrice}</p>
          <p className="mt-2" data-id="element-76" data-mp="3lvuf5usz195t">
            <span className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-gold-700" data-id="element-77" data-mp="3lwneiaplowdx">
              Hoy
            </span>
            <span className="mt-1 block font-display text-[3rem] font-extrabold leading-none tracking-tight text-plum-700 md:text-[3.6rem]" data-id="element-78" data-mp="3iwajal8hs5b">
              {product.price}
            </span>
          </p>

          <div className="mt-8" data-id="element-79" data-mp="dhvlizth1zvh">
            <CtaButton size="lg" href={checkoutUrl} className="w-full" data-id="element-80" data-mp="8gy1ehowivrc">
              {product.cta}
            </CtaButton>
          </div>

          <p className="mt-5 text-sm text-muted" data-id="element-81" data-mp="mf5swa3654v4">
            Acceso digital inmediato · Pago único · Garantía de 7 días
          </p>
        </div>

        {showUrgency && <div className="mx-auto mt-8 max-w-xl" data-id="element-82" data-mp="2o728busgiyv6">
            <CountdownPanel data-id="element-83" data-mp="2o9wtjojaonpn" />
          </div>}
      </div>
    </section>;
}